import { useLayoutElementsResponse } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/__internal__/useLayoutElementsResponse";
import { isValidForPage, isValidForPlatform } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/__internal__/utils/layoutElementFilterUtils";
import { useOneIndexedPageNumber } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useOneIndexedPageNumber";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
import { useMemo } from "react";
var TOP_OF_PAGE_PLACEMENTS = [
    ILayoutElement.Placement.BELOW_BREADCRUMB,
    ILayoutElement.Placement.ABOVE_TITLE,
    ILayoutElement.Placement.BELOW_TITLE,
    ILayoutElement.Placement.TOP
];
export var useTopOfPageLayoutElements = function() {
    var data = useLayoutElementsResponse().data;
    var isMobile = useViewport().isMobile;
    var pageNumber = useOneIndexedPageNumber();
    var layoutElements = useMemo(function() {
        var _data_layout_elements;
        return (_data_layout_elements = data === null || data === void 0 ? void 0 : data.layout_elements) !== null && _data_layout_elements !== void 0 ? _data_layout_elements : [];
    }, [
        data
    ]);
    return useMemo(function() {
        return layoutElements.filter(function(layoutElement) {
            return layoutElement.placement && TOP_OF_PAGE_PLACEMENTS.includes(layoutElement.placement);
        }).filter(function(layoutElement) {
            return isValidForPlatform(layoutElement, isMobile) && isValidForPage(layoutElement, pageNumber);
        });
    }, [
        layoutElements,
        isMobile,
        pageNumber
    ]);
};
